import { render, staticRenderFns } from "./SendToManagerModal.vue?vue&type=template&id=297f3380&scoped=true"
import script from "./SendToManagerModal.vue?vue&type=script&lang=js"
export * from "./SendToManagerModal.vue?vue&type=script&lang=js"
import style0 from "./SendToManagerModal.vue?vue&type=style&index=0&id=297f3380&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../test-qa.dotag.com/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "297f3380",
  null
  
)

export default component.exports